import { render, staticRenderFns } from "./editorImage.vue?vue&type=template&id=0c0fd4ad&scoped=true&"
import script from "./editorImage.vue?vue&type=script&lang=js&"
export * from "./editorImage.vue?vue&type=script&lang=js&"
import style0 from "./editorImage.vue?vue&type=style&index=0&id=0c0fd4ad&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0fd4ad",
  null
  
)

export default component.exports